import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'user',
    initialState: {
        user: {},
        isAuth: false,
    },
    reducers: {
        setIsAuth(state, action) {
            state.isAuth = action.payload
        },
        setUser(state, action) {
            state.user = action.payload
        },
    }
})

export default slice.reducer

export const {
    setIsAuth,
    setUser,
} = slice.actions